<template>
  <a-modal class="mint-product-details-modal-component" v-model="visible" v-on:close="onClose" :title="title"
           width="80%">
    <MINTProductDetailsComponent v-if="product" :search-params="searchParams" :product="product"
                                 :key="productKey"></MINTProductDetailsComponent>
    <template slot="footer">
      <a-button key="close" @click="onClose">
        Sluiten
      </a-button>
      <!--      <a-button key="submit" :loading="loading" @click="handleOk">-->
      <!--        Printen-->
      <!--      </a-button>-->
    </template>
  </a-modal>
</template>

<script>
import MINTProductDetailsComponent from "./ProductDetailsComponent";

export default {
  name: "MINTProductDetailsModalComponent",
  components: {MINTProductDetailsComponent},
  props: {
    product: {
      type: Object,
      required: true
    },
    searchParams: {
      type: Object,
      required: false,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      visible: true,
    }
  },
  computed: {
    title() {
      return `Alle rentetarieven ${this.product.name} (${this.product.productName}) ${this.latestInterestRateDate}`;
    },
    allInterestRates() {
      let interestRates = [];

      for (let months in this.product.interestRates) {
        interestRates.push(this.product.interestRates[months]);
      }

      return interestRates;
    },
    latestInterestRateDate() {
      return this.allInterestRates.map(interestRate => {
        return moment(interestRate.startingDate, moment.ISO_8601);
      }).sort((a, b) => {
        return a.isAfter(b) ? -1 : 1;
      }).slice(0, 1).pop().format('D/MM/YYYY');
    },
    productKey() {
      return this.product.uniqueKey;
    }
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit('close');
    }
  },
  mounted() {

  }
}
</script>
<style>
.mint-product-details-modal-component .ant-modal-close-icon {
  padding: 20px;
}

.mint-product-details-modal-component .ant-modal-body {
  padding: 0;
}
</style>